import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import talent14Logo from '../assets/TALENT14_LOGO.png';

const REHBER_URL = 'https://talent14-ogretmen-rehberi.vercel.app/';

const Rehber = () => {
  const [headerHeight, setHeaderHeight] = useState(73);

  // Dış sayfa scroll'unu kapat; scroll sadece iframe içinde olsun
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    window.scrollTo(0, 0);
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, []);

  // iframe header'ın hemen altından başlasın (mobil/masaüstü yüksekliği farklı)
  useEffect(() => {
    const header = document.querySelector('header');
    if (!header) return;
    const update = () => setHeaderHeight(header.offsetHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header logo={talent14Logo} />
      <div
        className="fixed inset-x-0 bottom-0 z-30 bg-slate-900"
        style={{ top: headerHeight }}
      >
        <iframe
          src={REHBER_URL}
          title="Talent14 Öğretmen Rehberi"
          className="block w-full h-full border-0"
          allow="fullscreen; clipboard-write"
          allowFullScreen
        />
      </div>
    </>
  );
};

export default Rehber;
